import React from 'react';
import { observer } from 'mobx-react';
import GrammarListService from '../services/GrammarListService';
import GrammarListFilter from './GrammarListFilter';

const GrammarListFilterContainer = () => (
  <GrammarListFilter
    values={GrammarListService.form.getValues()}
    onChange={GrammarListService.form.setValue}
    onSearch={GrammarListService.search}
  />
);

export default observer(GrammarListFilterContainer);
